import React from 'react';
import classNames from 'classnames';

type FlickAnimationProps = {
    className?: string;
    imgClassName?: string;
};

// TODO: Denis, rename?
// TODO: Denis, add a prop to control step count
export const FlickAnimation: React.FC<FlickAnimationProps> = ({
    className,
    imgClassName,
}) => {
    return (
        <div
            className={classNames(
                'flex flex-row items-center justify-center',
                className,
            )}>
            <div
                className={classNames(
                    "w-[85px] h-[85px] bg-[url('/img/bird-sprite.png')] bg-no-repeat bg-cover animate-preview",
                    imgClassName,
                )}
            />
        </div>
    );
};
